import { dateFormatter } from '../../../helpers/issue/date';

export function ticketingValueGetter({ data: { series } }): string {
  return dateFormatter(series);
}
